import { bbUrls, BOA_KEY, VERSION } from "../../constants/ApiUrls";
import { getData, updateData } from "../../networkManager/NetworkManager";

export const getAllUsersBA = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${bbUrls.BA_USERS}`);
};
export const getFile = async ({ userId, boaMediaId }) => {
  return await getData(
    BOA_KEY +
      VERSION +
      `${userId}/download-boa-media-stream?boaUserMediaId=${boaMediaId}`
  );
};

export const updateUserBA = async (data, id) => {
  return await updateData(BOA_KEY + VERSION + `${id}/${bbUrls.BA_USERS}`, data);
};
